/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppPostStreamQualityReportMutationRequest, WebAppPostStreamQualityReportMutationResponse, WebAppPostStreamQualityReport401, WebAppPostStreamQualityReport403 } from "../models/WebAppPostStreamQualityReport";

export function getWebAppPostStreamQualityReportUrl() {
  const res = { method: 'POST', url: `/web-app/v1/stream-quality/report` as const }
  return res
}

/**
 * @description Same as GET /stream-quality/report with `from`, `to`, and `stationsFilters` in the JSON body. Empty `stationsFilters` resolves to all stations for the authenticated client (resolved in stream-analysis).
 * @summary Get stream quality report (POST body)
 * {@link /web-app/v1/stream-quality/report}
 */
export async function webAppPostStreamQualityReport(data: WebAppPostStreamQualityReportMutationRequest, config: Partial<RequestConfig<WebAppPostStreamQualityReportMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<WebAppPostStreamQualityReportMutationResponse, ResponseErrorConfig<WebAppPostStreamQualityReport401 | WebAppPostStreamQualityReport403>, WebAppPostStreamQualityReportMutationRequest>({ method : "POST", url : getWebAppPostStreamQualityReportUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}